import React from "react";
import styles from "./add-button-expanded.module.css";
import { PlusCircleOutlined } from "@ant-design/icons";

const AddButtonExpanded = ({ buttonLabel, onClick }) => (
  <div className={styles.main} onClick={onClick}>
    <PlusCircleOutlined style={{ fontSize: 24, color: "#888888" }} />
    <p style={{ color: "#888888", margin: 1, padding: 0, fontSize: "13px" }}>
      {buttonLabel}
    </p>
  </div>
);

export default AddButtonExpanded;
